export const MAPBOX_TOKEN =
  'pk.eyJ1IjoieXNyYm9sbGVzIiwiYSI6ImNsaTRlMHAwdDEyNjIzbG8zd216emF6dW8ifQ.MydH7MJ6VqR0sc-veuGmFw';
